<div>
    <p>How long have you been living at your current address?</p>
    <form class="row" [formGroup]="residenceDurationForm">
        <div class="col-6 col-lg-4">
            <label>Years</label>
            <input class="form-control" type="number" formControlName="years" required>
        </div>
        <div class="col-6 col-lg-4">
            <label>Months</label>
            <input class="form-control" type="number" formControlName="months" required>
        </div>
    </form>
    <mat-error *ngIf="(residenceDurationInMonths < 24)">
        Two years of address history is required. You can add a previous address below.
    </mat-error>
    <div class="Vert-20"></div>
</div>
